import React, { useEffect, useState } from 'react';
import GameData from './Data.json'
import './Body.css';
import GroupsIcon from '@mui/icons-material/Groups';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import Pictures from './Carousel';
import Gametags from './GameTags';
import SimilarGames from './SimilarGames';
import CreateComment from './CreateComment';
// import PreviousComments from './PreviousComments';

import { addDoc, getDocs, collection, onSnapshot, doc, deleteDoc } from 'firebase/firestore';
import { auth, db } from './firebase-config';
import './PreviousComments.css'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import swal from 'sweetalert';



function BodyBetrayal() {

  const title = GameData.find(findGame).title;
  const subtitle = GameData.find(findGame).subtitle;
  const desc = GameData.find(findGame).desc;
  const gameTime = GameData.find(findGame).gameTime;
  const players = GameData.find(findGame).players;
  const age = GameData.find(findGame).age;
  const date = GameData.find(findGame).date;
  const review = GameData.find(findGame).review;
  const score = GameData.find(findGame).score;

  const [postList, setPostList] = useState([]);
  const commentCollectionRef = collection(db, "betrayal_comments");

  let totalScore = 0;
  let commentNumber = 0;


  function findGame(GameData) {
    return GameData.title === 'Betrayal at House on the Hill 3rd Edition'
  }

  postList.map((post) => {
    totalScore += post.postRating;
    commentNumber++;
  })

  
function CreateComment() {

   
  const [title, setTitle] = useState("");
  const [postComment, setPostComment] = useState("");
  const [postRating, setPostRating] = useState("");
  let rating;


  // let rating2;
  //may not need next line
  // let navigate = useNavigate();


async function writeToDB(){
  try{
  //       if (postRating > 100){
  //     postRating = 100;
  //   }

  // if (postRating === "" ){
  //   postRating = 100;
  // }
    await addDoc(commentCollectionRef, {
      title,
      postComment,
      postRating,
      author: { name: auth.currentUser.displayName, id: auth.currentUser.uid }
    });
    //may not need next line
    // navigate("/");
    // console.log(auth.currentUser);
    window.location.reload();

  } catch(err) {
    console.error("writeToDB failed. reason:", err);
  }
}


  // const createComment = async () => {
  // //   if (postRating > 100){
  // //     postRating = 100;
  // //   }

  // // if (postRating === "" ){
  // //   postRating = 100;
  // // }
  // try{
  //   await addDoc(commentCollectionRef, {
  //     title,
  //     postComment,
  //     postRating,
  //     author: { name: auth.currentUser.displayName, id: auth.currentUser.uid }
  //   });
  //   //may not need next line
  //   // navigate("Betrayal-At-House-3rd-Edition");
  //   // console.log(auth.currentUser);
  // } catch(err) {
  //   console.error("writeToDB failed. reason:", err);
  // }

  // };

  // useEffect(() => {
  //   if (!isAuth) {
  //       // navigate("/login");
  //   }
  // }, []);

  return (
    <div className="form-floating mb-3 w-50 comment">

      <div className="">
        <h1>Write Your Own Review </h1>
      </div>
      <form>
        <div className="inputGP">
          <label>Title</label>
          <input className="form-control"
            placeholder="Give comment a title"
            onChange={(event) => {
              setTitle(event.target.value);
            }}></input>
        </div>
        <div className="inputGP">
          <label>Rating</label>
          {/* I have no idea why this is working but apparently setting the min to 100 and max to 0 makes the code run */}
          <input className="form-control" type="number" min="100" max="0" placeholder="give game a rating" id="Rate"
            onChange={(event) => {
              rating = event.target.valueAsNumber;
              //making rating a global variable
              window.rating2 = rating;
             setPostRating(rating);
             
              
            }}></input>
        </div>
        <div className="inputGP">
          <label>Comment</label>
          <textarea className="form-control" placeholder="Write comment here"
            onChange={(event) => {
              setPostComment(event.target.value);
            }}></textarea>
          {!localStorage.isAuth ? <p>Login to add review</p> :
            <button onClick={() => {
             let ratingCheck = document.getElementById("Rate").valueAsNumber;
              // rating = setPostRating;
              if (ratingCheck >= 0 && ratingCheck <= 100 ){
                writeToDB();
              }
              else{
                swal("Oops! You frickin Baka!" ,  "Number must be between 0 and 100!" ,  "error")
              }
              
            }}>Submit Comment</button>
          }
          
          {/* <input type="submit" onClick={createComment}></input> */}

        </div>
      </form>

    </div>
  )
}

  //Try to figure out how to optimize this later
  function PreviousComments() {

    // const [postList, setPostList] = useState([]);

    // const deletePost = async (id) => {
    //     const postDoc = doc(db, 'betrayal_comments_2', id)
    //     await deleteDoc(postDoc)
    //     window.location.reload()
    // }


    useEffect(() => {
      const getPosts = async () => {
        const data = await getDocs(commentCollectionRef);
        setPostList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      };

      getPosts();
    }, []);

    return (
      <div className="PrevComments">

        <div className="container bg-15">
          <div className="row bg-16">
            <div className="communityScore">


              <h1>Number of comments: {commentNumber}</h1>
            </div>
            {postList.map((post) => {
              totalScore += post.postRating;
              return (
                <div className='container post'>
                  <div className="row postHeader">
                    <div className="col-8 title">
                      <h3>{post.title}</h3>
                    </div>
                    {/* Come back to debug the delete post button */}
                    {/* {localStorage.isAuth && post.author.id === auth.currentUser.uid &&
<div className='col-2 deletePost'>
<button onClick={() => { deletePost(post.id)}}><DeleteForeverIcon/></button>
</div>} */}

                    <div className="col-2 title">
                      <h1>{post.postRating}</h1>
                    </div>
                  </div>
                  <div className="row postAuthor">
                    <div className='container linebreak'></div>
                    <h3>{post.author.name}</h3>
                  </div>
                  <div className="postTextContainer">
                    {post.postComment}
                  </div>
                  {/* <div className="row">
            {localStorage.isAuth && post.author.id === auth.currentUser.uid &&
                <div className='deletePost'>
                    <div onClick={() => { deletePost(post.id) }}><DeleteForeverIcon /></div>
                </div>}

        </div> */}
                </div>);
            })}
          </div>
        </div>


      </div>
    )
  }





  return (
    <div class="container-fluid main">
     <div class="container">
     <div class=" headerCss row">
        <h1>{title}</h1>
        <h4 class="italics">"{subtitle}"</h4>
        <hr />

      </div>

      <div class="row main">
        <div class="col-lg-8 carousel">
          <Pictures game="Betrayal_At_House"/>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="infoCard">
              <p class="italics">{desc}</p>
            </div>
          </div>

          <div class="row">
            <div className='row justify-content-lg-center'>
              <div class=" tagsRight">
                <Gametags name={"Betrayal"} />
              </div>
            </div>

          </div>
        </div>
      </div>


      <div class="row main ">
        <div class="col-lg-8">
          <div class="row container ranks main">

            <div class="col">
              <div class=" background">
                <div class="hexagon">
                  <h1 class="editorScore">95.5</h1>
                </div>
              </div>
              <div class="row main justify-content-md-center">
                <div class="scoreBox">
                  <h1>Editor Score</h1>
                </div>
              </div>
            </div>
            <div className='col-md'>
              <div class="background">
                <div class="hexagon2">
                  <h1 class="editorScore">{Math.round(totalScore / commentNumber)}</h1>
                </div>
              </div>
              <div class="scoreBox">
                  <h1>Community Score</h1>
                </div>
            </div>

          </div>


          <div class="">
            <div class="row main justify-content-md-center">

              <div class="infoCardReview col-lg-4">
                <p class="italics">{review}</p>
              </div>
              <div class="infoCard2 col-lg-4">
                <article class="gameInfo">
                  <p class="gameInfoL"><CalendarMonthIcon />Release Date</p>
                  <p class="gameInfoR">{date}</p>
                </article>
                <hr />
                <article class="gameInfo">
                  <p class="gameInfoL"><GroupsIcon />Player Count</p>
                  <p class="gameInfoR">{players}</p>
                </article>
                <hr />
                <article class="gameInfo">
                  <p class="gameInfoL"><SupervisedUserCircleIcon />Age Range</p>
                  <p class="gameInfoR">{age}</p>
                </article>
                <hr />
                <article class="gameInfo">
                  <p class="gameInfoL"><ScheduleIcon />Game Time</p>
                  <p class="gameInfoR">{gameTime}</p>
                </article>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-4 main ">

          <SimilarGames similar={title}/>
        </div>
      </div>

      <div class="row d-flex align-items-center justify-content-center">
        <CreateComment comments={"test"} />
      </div>
      
      {/* Bottom <p> not using useState but only happens once */}
     </div>
     <div class="container-fluid d-flex align-items-center justify-content-center">
    
          <div className='comments-fix'>{PreviousComments()}</div>


        {/* <PreviousComments/> */}
      </div>
    </div>
  )
}

export default BodyBetrayal
